module.exports = __webpack_public_path__ + "static/media/vavcer.2ed05d22.png";